module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./CommonTipsView.js"));
	}, "LoginCommonTipsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LoginCommonTipsView!./src/pages/Login/CommonTips/CommonTipsView.js
// module id = 1766
// module chunks = 367